import { useCallback, useEffect, useMemo, useState } from 'react';
export default function usePaginationControls(opts) {
  const {
    selectedItem,
    paginator,
    onSelect
  } = opts;
  const selectedIndex = useMemo(() => {
    if (!selectedItem) {
      return -1;
    }
    return paginator.pageItems.findIndex(item => item.id === selectedItem.id);
  }, [selectedItem, paginator.pageItems]);
  const [hasCycled, setHasCycled] = useState(false);
  const [cannotCycle, setCannotCycle] = useState(false);
  const onNextItem = useCallback(() => {
    if (selectedIndex !== -1 && paginator.pageItems.length > 1) {
      if (selectedIndex < paginator.pageItems.length - 1) {
        setHasCycled(false);
        onSelect({
          data: paginator.pageItems[selectedIndex + 1]
        });
      } else {
        setHasCycled(true);
        onSelect({
          data: paginator.pageItems[0]
        });
      }
    } else {
      setCannotCycle(true);
    }
  }, [paginator.pageItems, selectedIndex, onSelect]);
  const onPreviousItem = useCallback(() => {
    if (selectedIndex !== -1 && paginator.pageItems.length > 1) {
      if (selectedIndex > 0) {
        setHasCycled(false);
        onSelect({
          data: paginator.pageItems[selectedIndex - 1]
        });
      } else {
        setHasCycled(true);
        onSelect({
          data: paginator.pageItems[paginator.pageItems.length - 1]
        });
      }
    } else {
      setCannotCycle(true);
    }
  }, [paginator.pageItems, selectedIndex, onSelect]);
  useEffect(() => {
    if (hasCycled) {
      setTimeout(() => {
        setHasCycled(false);
      }, 1500);
    }
    if (cannotCycle) {
      setTimeout(() => {
        setCannotCycle(false);
      }, 1500);
    }
  }, [hasCycled, cannotCycle]);
  return {
    selectedIndex,
    onNextItem,
    onPreviousItem,
    hasCycled,
    cannotCycle
  };
}